module.exports = "<ui-select class=\"c-select c-select--uiselect-multi\"\n           multiple tagging tagging-tokens=\"ENTER|,\" paste\n           ng-model=\"model[options.key]\"\n           on-select=\"to.onChange && to.onChange(model[options.key])\"\n           disabled=\"{{to.disabled}}\">\n  <ui-select-match placeholder=\"{{to.placeholder||('select'|translate)}}\">{{$item}}</ui-select-match>\n  <ui-select-choices repeat=\"item in []\">\n    {{ $select.search }}\n  </ui-select-choices>\n</ui-select>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/formly/uiSelectMultipleTagging.html
 ** module id = 549
 ** module chunks = 0
 **/